import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, serverTimestamp, onSnapshot } from 'firebase/firestore';

const firebaseConfig = {
	apiKey: process.env.REACT_APP_API_KEY || 'AIzaSyBKYhkUJjFcmdknQYWlaysJQMbTlkVSSUs',
	authDomain: process.env.REACT_APP_AUTH_DOMAIN || 'fir-push-notifications-3b805.firebaseapp.com',
	projectId: process.env.REACT_APP_PROJECT_ID || 'fir-push-notifications-3b805',
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET || 'fir-push-notifications-3b805.appspot.com',
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || '648487200750',
	appId: process.env.REACT_APP_APP_ID || '1:648487200750:web:86a50acaf7b23ed66590ff',
};

export const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

// Write a signal to Firestore so gym admin browsers can react in real time.
export const triggerMenuSettingsUpdate = (gymId) => {
	return setDoc(doc(db, 'menuSettingsUpdates', String(gymId)), {
		updatedAt: serverTimestamp(),
	});
};

// Subscribe to Firestore real-time updates for a gym's menu settings signal.
// Fires callback whenever the super admin triggers an update.
// Returns an unsubscribe function.
export const subscribeToMenuSettingsUpdates = (gymId, callback) => {
	return onSnapshot(doc(db, 'menuSettingsUpdates', String(gymId)), callback);
};

// Write a force-logout signal so the gym admin's browser session is terminated immediately.
export const triggerForceLogout = (gymId) => {
	return setDoc(doc(db, 'forceLogout', String(gymId)), {
		triggeredAt: serverTimestamp(),
	});
};

// Subscribe to force-logout signals for a gym.
// Returns an unsubscribe function.
export const subscribeToForceLogout = (gymId, callback) => {
	return onSnapshot(doc(db, 'forceLogout', String(gymId)), callback);
};
